/*
 * @copyright Internet Business Partner, all rights reserved (c) 2020
 * @author    Marek Lisiecki <m.lisiecki@ibp.net.pl>
 * @license   Commercial
 */

import { createRouter, createWebHistory } from "vue-router";
import Home from "@/components/Home";
import OfferDetails from "@/components/OfferDetails";
import NotFound from "@/components/NotFound";
import Search from "@/components/Search";

let routes = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: '/home',
        component: Home,
        name: 'Home',
        meta: {
            title: 'ARA NIERUCHOMOŚCI - DOMY, DZIAŁKI, MIESZKANIA, LOKALE',
            metaTags: [
                {
                    name: "keywords",
                    lang: "pl",
                    content: "nieruchomości, częstochowa, domy, mieszkania, Czestochowa, nieruchomosci, lokale, działki, sprzedaż, wynajem, Częstochowa, Sprzedaż Mieszkań, Sprzedaż domów, działki sprzedaż, biuro nieruchomości, lokale wynajem, Czgn, Agencja Nieruchomości ARA"
                },
                {
                    name: "description",
                    lang: "pl",
                    content: "Zapraszamy do zapoznania się z najlepszą ofertą domów i mieszkań na sprzedaż bądź wynajem"
                }
            ]
        },
        children: [
            {
                path: ':block',
                props: true,
                component: Home
            }
        ]
    },
    {
        path: '/search',
        name: 'Search',
        component: Search,
        meta: {
            title: 'ARA NIERUCHOMOŚCI - OFERTY',
        },
        children: [
            {
                meta: {
                    showModal: true
                },
                path: 'details/:id',
                name: 'OfferDetails',
                component: OfferDetails
            },
            {
                path: 'list/:page',
                component: Search
            }
        ]
    },
    {
        path: "/:catchAll(.*)",
        component: NotFound,
    }
];

const router = createRouter({
    history: createWebHistory(),
    base: process.env.BASE_URL,
    routes
});

router.beforeEach((to, from, next) => {
    const defaults = {
        title: 'ARA NIERUCHOMOŚCI'
    };

    const titleVal = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
    const metaValues = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    if (titleVal) {
        document.title = titleVal.meta.title || defaults.title;
    }

    for (let el of document.querySelectorAll('[data-v-meta]')) {
        el.parentNode.removeChild(el)
    }

    if (! metaValues) {
        return next();
    }

    for (let metaVal of metaValues.meta.metaTags) {
        const tag = document.createElement('meta');

        Object.keys(metaVal).forEach(key => {
            tag.setAttribute(key, metaVal[key]);
        });

        tag.setAttribute('data-v-meta', '');
        document.head.appendChild(tag);
    }

    next();
});

export default router;